module.exports = __webpack_public_path__ + "img/greenland.41271612.svg";